<template>
  <div class="listing backgroundList">

    <div  v-for="item in listData" :key="item.id" class="item full smooth hoverFade">
      <div v-on:click="pickItem(item)" class="image hover-fade smooth pointer"> <img v-bind:src="getThumb(item.preview)" /> </div>
       <color-list :background-data="item" v-if="currentBackgroundId == item.id" ></color-list>
    </div>

  </div>
</template>

<script>

import ColorList from 'components/Lists/ColorList'

export default {

  components: {
    ColorList,
  },

  props: ['listData'],

  data: function(){
    return{
      imageUrl: window.apiHandler.getUrl(),
    }
  },

  computed: {

    currentBackgroundId(){

      if(this.$store.state.background)
        return this.$store.state.background.id;

      return -1;
    }

  },

  methods: {

    getThumb(file){
      return window.appSettings.getResizedImageFromCloud(400, file, 'backgrounds/');
    },

    pickItem: function(item){
      this.$store.commit('resetPictureWallColor');
      this.$store.commit('background', item);
      this.trackEvent('background step');
    },

    reset: function(){
      this.$store.commit('resetChosenArticles');
    }

  },

  mounted: function () {

  }

}
</script>

<style lang="scss">

.backgroundList{
  height: 100%;
  overflow-y: scroll;

  img{
    max-width: none;
    width: 100%;
  }

}

</style>



// WEBPACK FOOTER //
// BackgroundList.vue?449fe3a7